import styled, { css, keyframes } from 'styled-components';

const pulsateBck = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`;

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  z-index: 1000;
`;

export const ChatIcon = styled.img``;

export const ChatButton = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2972e2 28.85%, #214882 100%);
  box-shadow: 0px 25px 50px -12px #00000040;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${({ $isDragging }) => ($isDragging ? 'grabbing' : 'grab')};
  user-select: none;
  touch-action: none;
  transition: ${({ $isDragging }) => ($isDragging ? 'none' : 'transform 0.2s ease')};
  ${({ $isOpen }) =>
    !$isOpen &&
    css`
      animation: ${pulsateBck} 2s ease-in-out infinite both;
    `}

  &:hover {
    transform: ${({ $isDragging }) => ($isDragging ? 'none' : 'scale(1.05)')};
  }

  &:active {
    cursor: grabbing;
  }
`;
export const ChatButtonNotification = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e63946;
  box-shadow: 0px 10px 15px -3px #0000001a;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: -4px;
`;
export const ChatModalBlock = styled.div`
  position: relative;
`;
export const ChatModal = styled.div`
  width: 537px;
  min-height: 490px;
  border-radius: 14px;
  box-shadow: 0px 20px 25px -5px #0000001a;
  position: relative;
  overflow: hidden;
  background: white;

  .action-button {
    max-height: 38px;
    max-width: 180px;
    color: #212529;
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    & div {
      gap: 5px;
    }
  }
  @media (max-width: 558px) {
    width: 380px;
  }
  @media (max-width: 396px) {
    width: 340px;
  }
  @media (max-width: 341px) {
    width: 280px;
  }
`;
export const ChatModalTopBorder = styled.div`
  background: linear-gradient(90deg, #2a72e2 25.48%, #235298 66.35%);
  height: 4px;
`;
export const ChatModalCloseButton = styled.div`
  width: 32px;
  height: 32px;
  border: 1px solid #d4d8dd;
  box-shadow: 0px 10px 15px -3px #0000001a;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -9px;
  top: -14px;
  z-index: 1;
  cursor: pointer;
`;
export const ChatModalCLoseButtonIcon = styled.img``;
export const ChatModalHeader = styled.div`
  padding: 24px;
  display: flex;
  align-items: center;
  position: relative;
  background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
  border-bottom: 1px solid #f1f5f9;
`;

export const ChatModalHeaderBackButton = styled.button`
  width: 15px;
  height: 15px;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 5px;
  border: none;
  transition: all 0.2s ease;
  flex-shrink: 0;
`;
export const ChatModalHeaderIconBlock = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #2b7fff 0%, #1d3557 100%);
  box-shadow: 0px 7.86px 11.79px -2.36px #0000001a;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ChatModalTitleIcon = styled.img``;
export const ChatModalHeaderTitleBlock = styled.div`
  padding-left: 12px;
  display: flex;
  align-items: center;
`;
export const ChatModalHeaderFlex = styled.div``;
export const ChatModalHeaderTitle = styled.h3`
  font-weight: 500;
  color: #0f172b;
  font-size: 18px;
  line-height: 28px;
`;
export const ChatModalHeaderSubTitle = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: #62748e;
`;
export const ChatModalHeaderNotification = styled.div`
  width: 55px;
  height: 26px;
  border-radius: 16px;
  border: 1px solid #ffc9c9;
  background: linear-gradient(90deg, #fef2f2 0%, rgba(255, 226, 226, 0.5) 100%);
  padding: 4px 10px;
  display: flex;
  align-items: center;
  margin-left: 16px;
`;
export const ChatModalHeaderNotificationDot = styled.div`
  width: 6px;
  height: 6px;
  background: #e63946;
  border-radius: 50%;
  margin-right: 6px;
`;
export const ChatModalHeaderNotificationNumber = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #c10007;
`;
export const ChatSearch = styled.div`
  border-bottom: 1px solid #f1f5f9;
  border-top: 1px solid #f1f5f9;
  padding: 12px;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.6;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 200px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 38px;
  border: 1px solid #d4d8dd;
  border-radius: 8px;
  padding: 0 36px 0 38px;
  font-size: 14px;
  color: #0f172b;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #94a3b8;
  }

  /* &:focus {
    border-color: #2d6cdf;
  } */
`;

export const SearchCloseButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.6;
  }

  img {
    width: 14px;
    height: 14px;
  }
`;

export const BackToListBtn = styled.div`
  border-radius: 10px;
  border: 0.5px solid #d4d8dd;
  background: #fff;
  width: 85px;
  height: 40px;
  margin: 10px 0;
  color: #1d3557;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
`;

export const BackToListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const BackArrow = styled.span`
  margin-right: 8px;
`;
